/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleUpgradeAcceptResponse } from './moduleUpgradeAcceptResponse';

export type GenericApiResponseModuleUpgradeAcceptResponseData = ModuleUpgradeAcceptResponse | null;
